<template>
    <div id="declarations" class="declarations-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="8" />
        <div class="px-8">
            <h3 class="mb-4" @click="quickView = !quickView"><span class="icon-chevron mr-2 text-sm" :class="[quickView ? '' : 'active']"></span> I declare and confirm the following:</h3>
            <div :class="[quickView ? 'flex' : '']">
                <CheckboxComponent :label="!quickView ? 'By submitting this application, I confirm that all information provided by me, and all confirmations given by me, as part of this application are true and correct in all material respects. I agree to inform AMT Futures Limited promptly in writing upon any change to the information I have provided.' : ''" :value="!!submission.declaration.confirm_correct_details" />

                <CheckboxComponent :label="!quickView ? 'I confirm that I have read and understood the information provided under Important Policies & Disclosures and that AMT Futures may execute my orders outside a Regulated Market, Multilateral Trading Facility or Organised Trading Facility.' : ''" :value="!!submission.declaration.confirm_understand_policies_and_disclosures" />

                <CheckboxComponent :label="!quickView ? 'If AMT Futures Limited accept my application, I agree to be bound by the Client Agreement and the other terms and documents referred to in it. I acknowledge and accept that the information provided by AMT Futures Limited in this application process will constitute part of the agreement between me and AMT Futures Limited if AMT Futures Limited accept my application.' : ''" :value="!!submission.declaration.agree_to_client_agreement" />

                <CheckboxComponent :label="!quickView ? 'I acknowledge and accept that, by submitting this application, I am making an offer to AMT Futures to receive services provided by AMT Futures Limited. I acknowledge that my submission of this application does not create any legal obligation of AMT Futures to provide any services to me.' : ''" :value="!!submission.declaration.confirm_receive_provided_services" />

                <CheckboxComponent :label="!quickView ? 'I agree to the processing of my special personal data as described in the Platform Privacy Policy for the purposes described in that policy.' : ''" :value="!!submission.declaration.agree_personal_data_processing" />

                <CheckboxComponent :label="!quickView ? 'Declaration confirmation.' : ''" :value="!!submission.declaration.declaration_confirmation" />

            </div>
            <HrComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import CheckboxComponent from '@adminComponents/inputs/CheckboxComponent';

export default {
    name: "DeclarationsComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        CheckboxComponent
    },
    computed: {
        ...mapGetters(["submission"])
    },
    data: function () {
        return {
            quickView: true
        };
    }
};
</script>
